import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined, CopyOutlined } from '@ant-design/icons';
import i18n from '../../../../_translations/i18n';
import { useTranslation } from 'react-i18next';

const DuplicateClusterModal = ({ 
    visible, 
    onClose, 
    onConfirm, 
    loading, 
    clusterData,
    isRTL,
    dmode 
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    fontFamily: 'Mulish, sans-serif',
                    fontWeight: '700',
                    color: dmode ? '#ccc' : '#333333'
                }}>
                    <ExclamationCircleOutlined style={{ color: '#FF6B35', fontSize: '18px' }} />
                    {t('DUPLICATE_CLUSTER')}
                </div>
            }
            open={visible}
            onCancel={onClose}
            centered
            width={450}
            footer={null}
            maskClosable={!loading}
            closable={!loading}
            bodyStyle={{ 
                padding: '24px',
                fontFamily: 'Mulish, sans-serif',
                backgroundColor: dmode ? '#2f353e' : '#fff'
            }}
            style={{
                direction: isRTL ? 'rtl' : 'ltr'
            }}
            styles={{
                header: {
                    backgroundColor: dmode ? '#2f353e' : '#fff',
                    borderBottom: 'none'
                },
                body: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                },
                content: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                }
            }}
        >
            <div style={{ marginBottom: '24px' }}>
                <p style={{ 
                    fontSize: '14px', 
                    color: dmode ? '#999' : '#666666', 
                    marginBottom: '16px',
                    lineHeight: '1.5'
                }}>
                    {t('ARE_YOU_SURE_DUPLICATE_CLUSTER')}
                </p>
                
                {clusterData && (
                    <div style={{
                        backgroundColor: dmode ? '#3a4149' : '#F8F9FA',
                        padding: '16px',
                        borderRadius: '8px',
                        border: dmode ? '1px solid #555' : '1px solid #E9ECEF'
                    }}>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: '600', color: dmode ? '#ccc' : '#333333' }}>{t('CLUSTER_NAME')}: </span>
                            <span style={{ color: dmode ? '#999' : '#666666' }}>{clusterData.clusterName}</span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: '600', color: dmode ? '#ccc' : '#333333' }}>{t('CODE')}: </span>
                            <span style={{ color: dmode ? '#999' : '#666666' }}>{clusterData.code}</span>
                        </div>
                    </div>
                )}

                <div style={{
                    marginTop: '16px',
                    padding: '12px',
                    backgroundColor: dmode ? '#4a4635' : '#FFF3CD',
                    border: dmode ? '1px solid #6b5b0f' : '1px solid #FFEAA7',
                    borderRadius: '6px',
                    fontSize: '13px',
                    color: dmode ? '#d4bf4a' : '#856404'
                }}>
                    <strong>{t('NOTE')}:</strong> {t('CLUSTER_DUPLICATE_NOTE')}
                </div>
            </div>

            <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end', 
                gap: '12px'
            }}>
                <Button
                    onClick={onClose}
                    disabled={loading}
                    style={{
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '80px',
                        backgroundColor: dmode ? '#3a4149' : '#fff',
                        borderColor: dmode ? '#555' : '#d9d9d9',
                        color: dmode ? '#ccc' : '#333'
                    }}
                >
                    {t('CANCEL')}
                </Button>
                <Button
                    type="primary"
                    onClick={onConfirm}
                    loading={loading}
                    icon={!loading ? <CopyOutlined /> : null}
                    style={{
                        backgroundColor: '#26B362',
                        borderColor: '#219653',
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '120px'
                    }}
                >
                    {loading ? t('DUPLICATING') : t('DUPLICATE')}
                </Button>
            </div>
        </Modal>
    );
};

export default DuplicateClusterModal;